var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"header-container"},[_c('div',{staticClass:"header",class:{ 'has-error': _vm.hasError }},[_c('span',{staticClass:"pay-total",attrs:{"tabindex":"0","role":"definition"}},[_vm._v("Pay "+_vm._s(_vm.orderTotal))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }